import React, { useEffect } from 'react';

import css from './StoryCardsEmbedded.module.scss';

const COMPANY_ID = process.env.MODE === 'prod' ? '6915ac88c6f45e65933e114d' : '65e045c007d8a840dd91fa52';
const STORY_ID = 'xLQvY9Y9v';

export const StoryCardsEmbedded = ({ id }: { id: string }) => {
  useEffect(() => {
    if (id !== COMPANY_ID) return;

    const script = document.createElement('script');
    const iframeWrapper = document.getElementById(`story-catalyst/${STORY_ID}`);
    const iframe = iframeWrapper?.querySelector<HTMLIFrameElement>('iframe');

    if (!iframe) {
      script.setAttribute('id', `script-story-catalyst/${STORY_ID}`);
      script.src = `https://storycards.co/catalyst/${STORY_ID}/sdk-prod.js?buildId=a32bcd4b-7ca4-47bf-9d60-c89304e1d530-1&ver=2`;
      script.async = true;
      script.dataset.id = 'catalyst/xLQvY9Y9v';

      document.body.appendChild(script);
    }

    return () => {
      if (iframe) iframe.remove();

      document.body.removeChild(script);
    };
  }, [id]);

  if (id !== COMPANY_ID) return null;

  return <div className={css.storyCardsEmbedded} id={`story-catalyst/${STORY_ID}`} />;
};
